<template>
    <div class="test-strip-analytics">
        <GrafanaIframe :url="testStripAnalyticsUrl" title="Test Strip Analytics Dashboard" />
    </div>
</template>

<script lang="ts" setup>
import GrafanaIframe from '@/components/GrafanaIframe.vue'
import { useBreadCrumbsStore } from '@/stores/breadCrumbs'
import { computed, onMounted } from 'vue'

const breadCrumbsStore = useBreadCrumbsStore()
const testStripAnalyticsUrl = computed(() => {
    return import.meta.env.VITE_ANALYTICS_TEST_STRIP_URL
})

onMounted(() => {
    breadCrumbsStore.$patch({
        items: [
            {
                text: `Test Strip Analytics`
            }
        ]
    })
})
</script>

<style lang="scss" scoped>
.test-strip-analytics {
    height: 100%;
    min-height: 0; // Allows flex child to shrink below content size when parent is a flex container
}
</style>
